// extracted by mini-css-extract-plugin
module.exports =  {"ctrlButtons":"ctrlButtons___T72l9","icon":"icon___WdMLv","ctrlZoomOut":"ctrlZoomOut___HZwDa","ctrlZoomIn":"ctrlZoomIn___qrvVh"};